import React from 'react';
import '../Styles/App.css';
import Header from '../components/Header/Header';
import DiscoverOrg from '../components/DiscoverOrg/DiscoverOrg';
import Footer from '../components/Footer/Footer';


const Discover = () => {
  return ( <>
     <Header />
    <DiscoverOrg/>
    <Footer />
 </>
  )
};

export default Discover;